// extracted by mini-css-extract-plugin
module.exports = {"categories":"style_categories__1Fp59","section":"style_section__29gRk","routeSearchAtCurrentPos":"style_routeSearchAtCurrentPos__CTsDs"};